
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'NoAccess',

  setup() {
    return {};
  },
});
